import React, { useState } from 'react';
import Button from './Button';
import api from '../services/api';
import toast from 'react-hot-toast';

const DiscordWebhookManager = ({ shop, onUpdate }) => {
  const [webhookUrl, setWebhookUrl] = useState(shop.discordWebhookUrl || '');
  const [isTesting, setIsTesting] = useState(false);

  const handleUpdateWebhook = async () => {
    try {
      const res = await api.put(`/shops/${shop._id}`, {
        discordWebhookUrl: webhookUrl,
      });
      onUpdate(res.data);
      toast.success('Webhook URL został zaktualizowany.');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Wystąpił błąd.');
      console.error(err);
    }
  };

  const handleTestWebhook = async () => {
    if (!webhookUrl) {
      toast.error('Wprowadź URL webhooka przed testowaniem.');
      return;
    }
    setIsTesting(true);
    try {
      const res = await api.post('/admin/discord/test', { webhookUrl });
      toast.success(res.data.message);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Nie udało się wysłać wiadomości.');
      console.error(err);
    } finally {
      setIsTesting(false);
    }
  };

  return (
    <div className="mt-8 p-4 border rounded-lg">
      <h2 className="text-2xl font-bold mb-4">Webhook Discord</h2>
      <div className="mb-4">
        <label htmlFor="webhookUrl" className="block text-sm font-medium text-gray-700">
          URL Webhooka
        </label>
        <div className="mt-1 flex rounded-md shadow-sm">
          <input
            type="text"
            name="webhookUrl"
            id="webhookUrl"
            className="input-class bg-gray-800 text-white border-gray-600 focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-none rounded-l-md sm:text-sm"
            value={webhookUrl}
            onChange={(e) => setWebhookUrl(e.target.value)}
            placeholder="https://discord.com/api/webhooks/..."
          />
          <Button onClick={handleUpdateWebhook} className="rounded-l-none rounded-r-none">
            Zapisz
          </Button>
          <Button onClick={handleTestWebhook} className="rounded-l-none" disabled={isTesting}>
            {isTesting ? 'Wysyłanie...' : 'Testuj'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DiscordWebhookManager;